import { render } from "./TotalizadorDecorado.vue?vue&type=template&id=bd89ba62&scoped=true&ts=true"
import script from "./TotalizadorDecorado.vue?vue&type=script&lang=ts"
export * from "./TotalizadorDecorado.vue?vue&type=script&lang=ts"

import "./TotalizadorDecorado.vue?vue&type=style&index=0&id=bd89ba62&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd89ba62"]])

export default __exports__